import { RegisterCompletePage } from "@/features/auth/pages/RegisterComplete";

const RegisterComplete = () => {
  return <RegisterCompletePage />;
};

export default RegisterComplete;
